<template>
  <v-btn
    v-bind="$attrs"
    :color="color"
    class="story-city-button"
    elevation="0"
    @click="$emit('click')"
  >
    <div class="button-text">
      <slot />
    </div>
  </v-btn>
</template>

<script>
export default {
  name: "StoryCitySolidButton",
  props: {
    color: {
      type: String,
      default: "primary",
    },
  },
};
</script>
